import { Component, OnInit,ElementRef,ViewChild ,ChangeDetectorRef} from '@angular/core';
import { LoginService } from '../login/login.service';
import { FormGroup,FormBuilder } from '@angular/forms';
import { Chart, ChartOptions, ChartData, Plugin,ChartDataset ,ChartType } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import moment from 'moment';
declare module 'chart.js' {
  interface PluginOptionsByType<TType extends keyof ChartTypeRegistry> {
    highlightLine?: {
      enabled: boolean;
      value: number;
    };
  }
}

@Component({
  selector: 'app-main-dashboard',
  templateUrl: './main-dashboard.component.html',
  styleUrls: ['./main-dashboard.component.css']
})
export class MainDashboardComponent implements OnInit {
  // Add this near your component or in a types file
  highlightValue: number = 50;

  public braChart2Options: ChartOptions<'bar'> = {
    responsive: true,
    plugins: {
      legend: { display: true },
      tooltip: { enabled: true },
      highlightLine: {
        enabled: true,
        value: this.highlightValue
      }
    },
    scales: {
      x: {},
      y: {
        beginAtZero: true,
        max: Math.max(100, this.highlightValue) ,// make sure highlightValue fits
        ticks: {
          callback: (value, index, ticks) => {
            const seen = new Set();
            return ticks.map(tick => {
              const v = tick.value.toString();
              if (v === this.highlightValue.toString() && !seen.has(v)) {
                seen.add(v);
                return `⭐ ${v}`;
              }
              return v;
            })[index];
          }
        }
        
        
      }
    }
  };

  // Register plugin once
 token:any
  storedData:any
  userTypes:any=[]
  productDetails:any=[]
  performanceForm!: FormGroup
  reminderForm!: FormGroup
teleCaller:any={}
backEndStaff:any={}
LiveCaseForm!: FormGroup
liveCaseData:any=[]
reminderCaseData:any
InterestedCaseData:any
ProductCaseData:any
InterestedMonth:any=new Date().toISOString().slice(0, 7)
ProductMonth:any=new Date().toISOString().slice(0, 7)
uTypes:any = [];

//  // Chart Options
public barChartOptions: ChartOptions<'bar'> = {
  responsive: true,
  plugins: {
    legend: { display: true },
    tooltip: {
      callbacks: {
        label: (context) => `${context.dataset.label}: ${context.raw} case`
      }
    }
  },
  scales: {
    y: { beginAtZero: false, title: { display: false, text: 'Case Count' } ,},
    x: { title: { display: false, text: 'Users' } }
  }
};

// ✅ Explicitly cast 'barChartType' as 'bar'
public barChartType: ChartType = 'bar' as const; 

// Corrected Chart Data Structure
public barChartData: ChartData<'bar'> = {
  labels: [], // Dynamic User Names
  datasets: [
    { data: [], label: 'Case Count', backgroundColor: '#42A5F5' }
  ]
};


// 2

public braChart2Labels: string[] = [];
public braChart2Type: ChartType = 'bar';

public braChart2Data = {
  labels: ['Case A', 'Case B', 'Case C'],
  datasets: [
    { data: [10, 15, 7], label: 'Interested Case Count', backgroundColor: 'blue' },
    { data: [5, 8, 3], label: 'Field Case Count', backgroundColor: 'orange' },
    { data: [2, 4, 1], label: 'Enrolled Case Count', backgroundColor: 'gray' }
  ]
};



perfomanceData:any=[]
  constructor(public loginService:LoginService,private formBuilder: FormBuilder,private cdr:ChangeDetectorRef) { }

  ngOnInit(): void {
    this.storedData = JSON.parse(localStorage.getItem("user") || '{}');
    this.token = localStorage.getItem('token');
   this.listUserType()
   this.listProducts()
   this.performanceForm = this.formBuilder.group({
    userType: [''],
    status: [''],
    date: [this.getTodayDate()]
     })
     this.LiveCaseForm= this.formBuilder.group({
      // userType: [''],
      status: ['Under Validation'],
      // date: [this.getTodayDate()]
       })
     this.reminderForm= this.formBuilder.group({
      product: [''],
      status: ['Under TeleCall'],
      date: [this.getTodayDate()],
      rows: ['10']
       })

       this.registerHighlightLinePlugin();

     
      
    
  }
 
  getTodayDate(): string {
    const today = new Date();
    return today.toISOString().split('T')[0]; // Format: YYYY-MM-DD
  }
  listUserType(){
    this.loginService.listUserType(this.token)
    .subscribe((response: any) => {
      if (response.status === 1) {
              this.userTypes =response.data
              this.uTypes = response.data;
              this.userTypes =  this.userTypes.filter(
                (userType: any) => userType.userType === 'Tele Caller' || userType.userType === 'Field Executive'||userType.userType === 'Backend Staff'
              );
             let item =  this.userTypes.filter(
              (userType: any) => userType.userType === 'Tele Caller'
            );
            let item2 =  this.userTypes.filter(
              (userType: any) => userType.userType === 'Backend Staff'
            );
            this.teleCaller=item[0]

                this.backEndStaff=item2[0]

        this.performanceForm.get('userType')?.patchValue(item[0]);
        this.performanceForm.get('status')?.patchValue('telecall');
this.perfomanceDashboard()
 this.liveCaseCout()
this.interestedCases()
this.productCases()
// this.reminderCases()
      }
    })
   
  }

   perfomanceDashboard(){
console.log(this.performanceForm.value.userType);

    if(this.performanceForm.value.userType.userType!='Tele Caller'){
      let data={
        "userType":this.performanceForm.value.userType._id,
        "date":this.performanceForm.value.date,
        "status":this.performanceForm.value.status
      }
     
      this.loginService.perfomanceDashboard(this.token,data)
      .subscribe((response: any) => {
        if (response.status === 1) {
         this. perfomanceData=response.data
        }})

      
  
    }else{
      let data={
        "userType":this.performanceForm.value.userType._id,
        "date":this.performanceForm.value.date,
        "status":this.performanceForm.value.status
      }
      this.loginService.teleCallerPerformanceData(this.token,data)
      .subscribe((response: any) => {
        if (response.status === 1) {
         this.perfomanceData=response.data
        }})
     
    } 
   

  }

  liveCaseCout(){
    let manager:any;
    let data: any = {
      "date": this.getTodayDate(),
      "products": this.storedData.products,
      "status": this.LiveCaseForm.value.status
    };
    
    // Conditionally add "userType" only if it has a value
    const userType = this.LiveCaseForm.value.status === 'Under Validation'
      ? this.backEndStaff
      : this.LiveCaseForm.value.status === 'Under TeleCall'
        ? this.teleCaller
        : '';

    if(this.uTypes.length){
        this.uTypes.forEach((element:any) => {
             if(element.userType=='Manager'){
               manager = element._id;
             }
        });
      }
    
    if (userType) {
      data["userType"] = userType._id;
    }

     if(this.LiveCaseForm.value.status=='Interested' || this.LiveCaseForm.value.status=='Field Visit'){
       data["userType"] = manager;
    }
    this.loginService.liveCaseCout(this.token,data)
    .subscribe((response: any) => {
      if (response.status === 1) {
       this.liveCaseData=response.data
      //  this.barChartData.labels = this.liveCaseData.map((user:any) => user.name);
      //  this.barChartData.datasets[0].data = this.liveCaseData.map((user:any) => user.caseCount);
       const updatedLabels = this.liveCaseData.map((user: any) => user.name);
       const updatedData = this.liveCaseData.map((user: any) => user.caseCount);
   
       // Assign a new object to trigger change detection
       this.barChartData = Object.assign({}, this.barChartData, {
         labels: updatedLabels,
         datasets: [{ ...this.barChartData.datasets[0], data: updatedData }]
       });
      }})


      // const dynamicUsers = [
      //   { name: 'John', hours: 8 },
      //   { name: 'Alice', hours: 7 },
      //   { name: 'Bob', hours: 6 },
      //   { name: 'Emma', hours: 9 },
      //   { name: 'David', hours: 5 }
      // ];
  
      // Update Chart Labels & Data
     
  }
  

  listProducts(){

    this.loginService.listProducts(this.token).subscribe((response: any) => {
      if (response.status === 1) {
        this.productDetails = response.data
        console.log("",this.productDetails[0].name);
        
        this.reminderForm.get('product')?.patchValue(this.productDetails[0]);
        this.reminderCases()
      
      }
    });
  
        
  }
    format(date:any){
        return moment(date).format(`DD-MM-YYYY \n \nHH:mma`);
       
       }
  
  reminderCases(){

    let data={
      "products":[this.reminderForm.value.product._id],
      "date":this.reminderForm.value.date,
      "status":this.reminderForm.value.status,
      // "rows":this.reminderForm.value.rows
    }
    this.loginService.reminderCases(this.token,data)
    .subscribe((response: any) => {
      if (response.status === 1) {
       this.reminderCaseData=response.data
      }})
  }
  interestedCases(){
    const monthName = new Date(this.InterestedMonth).toLocaleString('en-US', { month: 'long' });

    let data={
    userType:this.teleCaller._id,
     month:monthName
    }
    this.loginService.interestedCases(this.token,data)
    .subscribe((response: any) => {
      if (response.status === 1) {
       this.InterestedCaseData=response.data
      this. highlightValue=response.data.length>0?response.data[0].TargetCount:0
       const interestedData = this.InterestedCaseData.map((item: any) => item.Interested || 0);
       const fieldData = this.InterestedCaseData.map((item: any) => item['Field Visit'] || 0);
       const enrolledData = this.InterestedCaseData.map((item: any) => item['Client Enrolled'] || 0);
       console.log(interestedData);
       
       // Set dynamic labels from InterestedCaseData
       this.braChart2Labels = this.InterestedCaseData.map((item: any) => item.name);
       
       // Assign dynamic data to braChart2Data
       this.braChart2Data = {
        labels: this.InterestedCaseData.map((user:any) => user.name),
        datasets: [
          {
            data:interestedData,
            label: 'Interested Case Count',
            backgroundColor: 'blue'
          },
          {
            data: fieldData,
            label: 'Field Case Count',
            backgroundColor: 'orange'
          },
          {
            data: enrolledData,
            label: 'Enrolled Case Count',
            backgroundColor: 'gray'
          }
        ]
      };
      
      this.braChart2Options = {
        responsive: true,
        plugins: {
          legend: { display: true },
          tooltip: { enabled: true },
          // Cast to any to bypass TS check for custom plugin
          ...( { highlightLine: { enabled: true, value: this.highlightValue } } as any )
        },
        scales: {
          x: {},
          y: {
            beginAtZero: true,

            max: Math.max(100, this.highlightValue), // make sure highlightValue fits

            ticks: {
              callback: (value, index, ticks) => {
                const seen = new Set();
                return ticks.map(tick => {
                  const v = tick.value.toString();
                  if (v === this.highlightValue.toString() && !seen.has(v)) {
                    seen.add(v);
                    return `⭐ ${v}`;
                  }
                  return v;
                })[index];
              }
            }
            
          }
        }
      };
      
      console.log("Updated Chart Data:", this.braChart2Data);
    }})
      
  }
  productCases(){
    const monthName = new Date(this.ProductMonth).toLocaleString('en-US', { month: 'long' });

    let data={
     month:monthName,
     products:this.storedData.products
    }
    this.loginService.productCases(this.token,data)
    .subscribe((response: any) => {
      if (response.status === 1) {
       this.ProductCaseData=response.data
      
      }})
  }
private registerHighlightLinePlugin(): void {
  const highlightLinePlugin: Plugin<'bar'> = {
    id: 'highlightLine',
    afterDraw(chart) {
      const pluginOptions = chart.options.plugins?.highlightLine;
      if (!pluginOptions?.enabled) return;
  
      const yValue = pluginOptions.value;
      const yScale = chart.scales['y'];
  
      if (yScale && yValue != null) {
        // Ensure value is within the scale bounds
        const min = yScale.min;
        const max = yScale.max;
        if (yValue < min || yValue > max) return;
  
        const y = yScale.getPixelForValue(yValue);
        const ctx = chart.ctx;
  
        ctx.save();
        ctx.beginPath();
        ctx.moveTo(chart.chartArea.left, y);
        ctx.lineTo(chart.chartArea.right, y);
        ctx.strokeStyle = 'red';
        ctx.lineWidth = 2;
        ctx.setLineDash([5, 5]);
        ctx.stroke();
        ctx.restore();
  
        // Optional: Draw label near the line
        ctx.fillStyle = 'red';
        // ctx.fillText('Target: ' + yValue, chart.chartArea.left + 5, y - 5);
      }
    }
  };
  

    // ✅ Register only once
    if (!Chart.registry.plugins.get('highlightLine')) {
      Chart.register(highlightLinePlugin);
    }
  }
}
